import { getStorage } from '../storage';

export function getUserToken(): string | null {
  const { getItem } = getStorage();
  return getItem('token') || null;
}
